import React from 'react'
import {Col, Row,} from 'react-bootstrap'
import {MultiSelect} from 'react-multi-select-component'
const CreateScriptBody = ({
  payload,
  setPayload,
  languageData,
  productsData,
  selectedLanguage,
  selectedProducts,
  setSelectedLanguage,
  setSelectedProducts,
  dataFromGetScript,
}: any) => {
  const handleValueScriptChange = (value: any) => {
    setPayload((prev: any) => {
      return {...prev, voice: value}
    })
  }
  const handleTimeConditionChange = (value: any) => {
    setPayload((prev: any) => {
      return {...prev, timeConditionCheck: value === '1'}
    })
  }

  const handleLanguageChange = (values: any) => {
    console.log(values)
    //selected Language length is greater than new selected values length, then a language is removed
    if (selectedLanguage.length > values.length) {
      const removedLanguageId = selectedLanguage.filter(
        (prevLanguage: any) => !values.includes(prevLanguage)
      )[0].value

      //remove questions of that language too
      const removedQuestions = payload.scriptQuestions
        .filter((language: any) => language.languageId === removedLanguageId)[0]
        ?.questions?.map((question: any) => question.id)
      setPayload((prev: any) => {
        return {
          ...prev,
          scriptQuestions: prev.scriptQuestions.filter(
            (language: any) => language.languageId !== removedLanguageId
          ),
        }
      })
      //if removed existing language during edit add that lang id to payload
      if (dataFromGetScript?.exisitingLanguages?.includes(removedLanguageId)) {
        //to get masterId of existing language because we have to send master id if that language deleted
        const {masterId: removedLanguageMasterId} =
          dataFromGetScript?.existingLanguagesMasterId.filter(
            ({languageId}: any) => languageId === removedLanguageId
          )[0]
        setPayload((prev: any) => {
          return {
            ...prev,
            deleteScriptLanguages: [...prev.deleteScriptLanguages, removedLanguageMasterId],
            deleteScriptQuestions: [...prev.deleteScriptQuestions, ...removedQuestions],
          }
        })
      }
    } else if (selectedLanguage.length < values.length) {
      setPayload((prev: any) => {
        return {
          ...prev,
          scriptQuestions: [
            ...prev.scriptQuestions,
            {
              languageId: `${values[values.length - 1].value}`,
              languageName: `${values[values.length - 1].label}`,
              questions: [],
            },
          ],
        }
      })
    }
    setSelectedLanguage(values)

    //to add language ids array for api call
    setPayload((prevpayload: any) => {
      return {
        ...prevpayload,
        languageIds: values.map(({label, value}: any) => value),
      }
    })
  }
  const handleProductChange = (values: any) => {
    if (selectedProducts.length > values.length) {
      //get the ID of removed language
      const removedProductId = selectedProducts.filter(
        (prevLanguage: any) => !values.includes(prevLanguage)
      )[0].value
      //check whether the removed language ID is in product ID's got from the get script
      if (dataFromGetScript?.existingProducts?.includes(removedProductId)) {
        setPayload((prev: any) => {
          return {
            ...prev,
            deleteProducts: [...prev.deleteProducts, removedProductId],
          }
        })
      }
    }
    setSelectedProducts(values)
  }
  return (
    <>
      <div className='d-flex justify-content-between w-100 mb-4'>
        <h4 className='text-gray-800 fs-3 fw-bold'>Script Details</h4>
        <div>
          <div className='form-check form-switch form-check-custom form-check-solid'>
            <span className='badge-light-danger p-2 rounded-3'>Inactive</span>
            <input
              className='form-check-input mx-2'
              style={{backgroundColor:'#808080'}}
              type='checkbox'
              value=''
              id='flexSwitchDefault'
              checked={payload.isActive}
              onChange={(e) =>
                setPayload((prev: any) => {
                  return {...prev, isActive: !prev.isActive}
                })
              }
            />
            <label className='form-check-label ms-0' htmlFor='flexSwitchDefault'>
              <span className='badge-light-success rounded-3 p-2 '>Active</span>
            </label>
          </div>
        </div>
      </div>
      <div className='fixed-height-body'>
      <form>
        <Row className='mt-5 no-gutters noPadding mb-5'>
          <Col sm md lg={6} >
            <label className='d-flex align-items-center mb-2 required'>
              <span className='fs-6 fw-semibold lh-23'>Script Name</span>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter Script Name'
              id='ScriptName'
              name='scriptName'
              value={payload.name}
              onChange={(e) =>
                setPayload((prev: any) => {
                  return {...prev, name: e.target.value}
                })
              }
            />
          </Col>
          <Col sm md lg={6}>
            <label className='d-flex align-items-center mb-2'>
              <span className='fs-6 fw-semibold lh-23'>Product Name</span>
            </label>
      
            <MultiSelect
              options={productsData}
              value={selectedProducts}
              className='create-script-dropdown'
              hasSelectAll={false}
              onChange={handleProductChange}
              labelledBy='Select Option'
              overrideStrings={{selectSomeItems: 'Select Option'}}
            />

            {/* <Select
       value={selectedProducts}
    isMulti
    hideSelectedOptions={false}
    name="colors"
    
    options={colourOptions}
    className="basic-multi-select createScript"
    classNamePrefix="select"
    onChange={(value)=>setSelectedProducts(value)}
  /> */}
          </Col>
          <Col sm md lg={6} className="position-relative mt-5">
            <label className='d-flex align-items-center mb-2 required'>
              <span className='fs-6 fw-semibold lh-23'>Language</span>
            </label>
            <MultiSelect
              options={languageData}
              value={selectedLanguage}
              className='create-script-dropdown'
              hasSelectAll={false}
              onChange={handleLanguageChange}
              labelledBy='Select Option'
              overrideStrings={{selectSomeItems: 'Select Option'}}
            />
            {selectedLanguage.length === 0 && (
              <span className='text-danger position-absolute'>
                Please select atleast one language
              </span>
            )}
          </Col>
          <Col sm md lg={6} className='mt-5'>
            <label className='d-flex align-items-center mb-2'>
              <span className='fs-6 fw-semibold lh-23'>Voice</span>
            </label>
            <select
              id='Voice'
              aria-label='select brand'
              className='form-select form-select-solid'
              value={payload.voice}
              onChange={(e) => handleValueScriptChange(e.target.value)}
            >
              <option value='Male'>Male</option>
              <option value='Female'>Female</option>
            </select>
          </Col>
          <Col sm md lg={6} className='mt-5'>
            <label className='d-flex align-items-center mb-2'>
              <span className='fs-6 fw-semibold lh-23'>Time Condition Check</span>
            </label>
            <select
              id='TimeconditionCheck'
              aria-label='select brand'
              className='form-select form-select-solid'
              value={payload.timeConditionCheck ? '1' : '0'}
              onChange={(e) => handleTimeConditionChange(e.target.value)}
            >
              <option value='1'>Yes</option>
              <option value='0'>No</option>
            </select>
          </Col>
        </Row>
        <label className='fs-6 fw-semibold mb-2'>Script Description</label>
        <textarea
          className='form-control form-control-solid'
          value={payload.scriptDescription}
          onChange={(e) =>
            setPayload((prev: any) => {
              return {...prev, scriptDescription: e.target.value}
            })
          }
          placeholder='Enter Script Description'
          name='details_description'
        >
        </textarea>
      </form>
      </div>
    
    </>
  )
}
export default CreateScriptBody
